import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import { handleError } from '../../store/features/alertSlice';
import businessUnitsService from '../../services/business_unit.service';
const BusinessUnitEditForm = _ref => {
  let {
    bussinessUnitToEdit,
    setIsEditing,
    company,
    setCompany,
    loading,
    setLoading,
    index
  } = _ref;
  const [businessUnit, setBusinessUnit] = useState(null);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setBusinessUnit(bussinessUnitToEdit);
  }, [bussinessUnitToEdit]);
  const handleChange = e => {
    const value = e.target.value;
    setBusinessUnit({
      ...businessUnit,
      [e.target.name]: value
    });
  };
  const handleEditBusinessUnit = async () => {
    try {
      const editedBu = await businessUnitsService.update(company.id, businessUnit);
      const newBusinessUnits = company.business_units;
      newBusinessUnits[index] = editedBu;
      setCompany({
        ...company,
        business_units: newBusinessUnits
      });
      setLoading(true);
      setIsEditing(false);
    } catch (e) {
      dispatch(handleError(e));
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('Name')), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Control, {
    name: "name",
    onChange: handleChange,
    value: businessUnit?.name,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('State')), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "state",
    onChange: handleChange,
    value: businessUnit?.state,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: "active"
  }, "Active"), /*#__PURE__*/React.createElement("option", {
    value: "not_active"
  }, "Not Active")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: businessUnit?.name?.length < 1,
    onClick: () => handleEditBusinessUnit(),
    icon: "save",
    iconPosition: 'left',
    loading: loading,
    variant: "primary"
  }, t('edit_business_unit')))));
};
export default BusinessUnitEditForm;